module.exports = __webpack_public_path__ + "media/flags/cw-ce5edd6e.svg";